import { useQuery } from 'react-query'
import commandBusAPI from '../service/commandBusAPI'

export const useCommandHistory = (
  devEui?: string,
  page: number = 1,
  pageSize: number = 20,
) => {
  const query = useQuery({
    queryKey: ['command-bus', 'history', devEui, page, pageSize],
    queryFn: () => commandBusAPI.getCommandHistory(devEui as string, page, pageSize),
    enabled: Boolean(devEui),
    // keepPreviousData garde l'ancien dataset visible pendant le chargement
    // de la page suivante — évite le clignotement de l'UI lors de la pagination.
    keepPreviousData: true,
    staleTime: 5_000,
  })

  return query
}

export default useCommandHistory
